import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login'
import Main from '../views/Main'
import AuthorCenter from '../views/AuthorCenter'
import Partner from '../views/Partner'
import Protocol from '../views/Protocol'
import Policy from '../views/Policy'
import TXInfo from '../views/TXInfo'
import ContactUs from '../views/ContactUs'
import Share from '../views/Share'
import About from '../views/About'
import NotFound from '../views/NotFound'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      component: Main,
      meta:{
        title:'塔兮 | 因为塔兮,所以简单'
      }
    },
    {
      path: '*',
      component: NotFound,
      meta:{
        title:'塔兮 | 因为塔兮,所以简单'
      }
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/authorcenter',
      component: AuthorCenter
    },
    {
      path: '/partner',
      component: Partner,
      meta:{
        title:'塔兮 | 合伙人'
      }
    },
    {
      path: '/policy',
      component: Policy
    },
    {
      path: '/protocol',
      component: Protocol
    },
    {
      path: '/txInfo',
      component: TXInfo,
      meta:{
        title:'塔兮 | 功能介绍'
      }
    },
    {
      path: '/contactUs',
      component: ContactUs,
      meta:{
        title:'塔兮 | 联系我们'
      }
    },
    {
      path: '/share/:id',
      name:'share',
      component: Share,
      meta:{
        title:'塔兮 | 分享'
      }
    },
    {
      path: '/about',
      component: About,
      meta:{
        title:'塔兮 | 关于'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js